import { DCSCondition } from "react-migration/lib/typings/comparables/dcs";
import { ComparablesFilterFields } from "../components/Filters/FiltersWithClear";

export function FilterDCSConditions(
  dcsConditions?: DCSCondition[],
  disabledFields?: Set<ComparablesFilterFields>
): DCSCondition[] | undefined {
  const exclude = (field: ComparablesFilterFields): boolean => disabledFields?.has(field) ?? false;

  // console.log(hiddenFields);
  return dcsConditions?.filter((condition) => {
    if (exclude("dcsConditions")) {
      return false;
    } else if (exclude("dcsConditions.Commercial") && condition.designation === "Commercial") {
      return false;
    } else if (exclude("dcsConditions.Other") && condition.designation === "Other") {
      return false;
    } else if (exclude("dcsConditions.Residential") && condition.designation === "Residential") {
      return false;
    }

    return true;
  });
}
